<template>
  <v-container grid-list-sm>
    <v-layout>
      <v-flex xs12 md6 offset-sm3>
        <v-card :color="$store.state.sysBackgroundColor">
          <EncabezadoReporte :titulo="titulo" :accion="accion" @ejecutarAccion="ejecutarAccion" />
          <v-card-text>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex>
                  <v-radio-group v-model="itemActivo.FiltroPuntoVenta" :mandatory="false">
                    <v-radio label="Todo" value="Todo"></v-radio>
                    <v-radio label="Un Punto de Venta" value="Uno"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md8 v-if="itemActivo.FiltroPuntoVenta == 'Uno'">
                  <SelectPuntoVenta :model="itemActivo.Id_PuntoVenta" :rules="[rules.requerido]"
                    @seleccionarItem="seleccionarPuntoVenta" />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <SelectRubro :model="itemActivo.Id_Rubro" :rules="[rules.requerido]"
                    @seleccionarItem="seleccionarRubro" />
                </v-flex>
                <v-flex xs12 md6>
                  <SelectSubrubro :model="itemActivo.Id_Subrubro" :Id_Rubro="itemActivo.Id_Rubro"
                    :rules="[rules.requerido]" @seleccionarItem="seleccionarSubrubro" />
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <PieCrud :loading="loading" />
        </v-card>
      </v-flex>
    </v-layout>
    <Mensaje :activo="mensajeActivo" :tipo="mensajeTipo" :titulo="mensajeTitulo" :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion" />
  </v-container>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import EncabezadoReporte from "@/components/EncabezadoReporte";
import PieCrud from "@/components/PieCrud";
import Mensaje from "@/components/Mensaje";
import SelectPuntoVenta from "@/components/Sistema/SelectPuntoVenta";
import SelectRubro from "@/components/Stock/SelectRubro";
import SelectSubrubro from "@/components/Stock/SelectSubrubro";
export default {
  name: "StockListarSaldos",
  components: {
    EncabezadoReporte,
    PieCrud,
    Mensaje,
    SelectPuntoVenta,
    SelectRubro,
    SelectSubrubro
  },
  data() {
    return {
      titulo: "Inventario",
      itemVacio: {
        FiltroPuntoVenta: "Todo",
        Id_PuntoVenta: 0,
        NombrePuntoVenta: "",
        Id_Rubro: 0,
        NombreRubro: "",
        Id_Subrubro: 0,
        NombreSubrubro: ""
      },
      itemActivo: {},
      rules: {
        requerido: v => !!v || "Requerido"
      },
      loading: false,
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      accion: ""
    };
  },
  created() {
    this.inicializar();
  },
  methods: {
    ejecutarAccion(accion) {
      this.accion = accion;
      switch (accion) {
        case "Imprimir":
        case "ExportarXls":
          if (this.$refs.form.validate()) this.imprimir();
          break;
        case "CancelarError":
          this.mostrarMensaje(false);
          this.ejecutarAccion("Inicializar");
          break;
        case "Inicializar":
          this.$refs.form.resetValidation();
          this.inicializar();
          break;
      }
    },
    inicializar() {
      this.itemActivo = Object.assign({}, this.itemVacio);
    },
    seleccionarPuntoVenta(item) {
      this.itemActivo.Id_PuntoVenta = item.Id_PuntoVenta;
      this.itemActivo.NombrePuntoVenta = item.Nombre;
    },
    seleccionarRubro(item) {
      this.itemActivo.Id_Rubro = item.Id_Rubro;
      this.itemActivo.NombreRubro = item.Nombre;
    },
    seleccionarSubrubro(item) {
      this.itemActivo.Id_Subrubro = item.Id_Subrubro;
      this.itemActivo.NombreSubrubro = item.Nombre;
    },
    imprimir() {
      this.loading = true;
      HttpHelper.getBlob("Articulo/ListarSaldos", {
        accion: this.accion,
        filtroPuntoVenta:
          this.itemActivo.FiltroPuntoVenta == "Todo"
            ? this.itemActivo.FiltroPuntoVenta
            : this.itemActivo.NombrePuntoVenta,
        id_PuntoVenta:
          this.itemActivo.FiltroPuntoVenta == "Todo"
            ? 0
            : this.itemActivo.Id_PuntoVenta,
        id_Subrubro: this.itemActivo.Id_Subrubro,
        nombreRubro: this.itemActivo.NombreRubro,
        nombreSubrubro: this.itemActivo.NombreSubrubro
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          let fileName = response.headers["content-disposition"]
            .split(";")[1]
            .split("=")[1]
            .trim();
          link.setAttribute("download", "Reporte_" + fileName);
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    mostrarError(error) {
      var detalle;
      detalle =
        error.response == undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
